import React, {useState} from "react"
import { useNavigate } from 'react-router-dom';
import { Layout, Button, Space, Typography, Card, Form, message } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { CustomerForm } from '../components/CustomerForm';

import { useCustomers } from "../../hooks/data/useCustomers";

export const CustomerCreatePage = () => {

  // form status
  const [isSaving, setIsSaving] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  // customer form
  const [customerForm] = Form.useForm();
  // customer hook
  const { createCustomer } = useCustomers();

  const handleAddressCopyClick = () => {
    customerForm.setFieldsValue({
      billingAddress: customerForm.getFieldsValue(['shippingAddress'])['shippingAddress']
    });
  }

  const handleSaveClick = async () => {
    try {
      setIsSaving(true);
      setIsDisabled(true);
      // Validate all fields in the form
      const values = await customerForm.validateFields();
      console.log('Form values validated:', values);

      // Prepare data for the API call 
      const createPayload = {
        ...values, // Spread the validated form values
      };

      // Call your update API endpoint
      await createCustomer(createPayload);
      message.success('Customer successfully created!');

    } catch (error: any) {
      let generalMessage = 'Failed to create customer';
      console.error(generalMessage.concat(': ', error));
      setIsDisabled(false);
      if (error.response && error.response.data && error.response.data.message) {
        let errorMessage = error.response.data.message;
        
        if(Array.isArray(errorMessage)){
          //handle validation error
          message.error(`Invalid field: ${errorMessage.map(el => {return el.property})}`);
        }
        else{
          message.error(generalMessage.concat(". ", errorMessage));
        }
      } else {
        message.error(generalMessage.concat('. Unhandled exception.'));
      }
    } finally {
      setIsSaving(false); // Reset saving state
      navigate('/customers');
    }
  };
      
  return (    
    <Layout.Content>
      <PageHeader 
        onBack={() => navigate(-1)}
        title={'New customer '}
        extra={(
          <Button type="primary" onClick={handleSaveClick} loading={isSaving}>
              Save
          </Button>
        )
        }>
      </PageHeader>
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Card>
          <Typography.Title level={4}>Personal data</Typography.Title>
          <CustomerForm customerForm={customerForm} formDisabled={isDisabled} copyAddressCallback={handleAddressCopyClick}/>
        </Card>
      </Space>
    </Layout.Content>
);
}